var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcCustomFrontPage = function SvgIcCustomFrontPage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 66 66",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    fill: "#121923",
    d: "M51.37 19.82c0-1.11-.9-2.01-2.01-2.01H3.99c-1.11 0-2.01.9-2.01 2.01v27.37h49.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1.98 47.19v6.61c0 1.11.9 2.01 2.01 2.01h45.37c1.11 0 2.01-.9 2.01-2.01v-6.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M19.32 55.81h14.71v4.17H19.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M38.16 59.98H15.2c-1.11 0-2.01.9-2.01 2.01V64h26.98v-2.01c0-1.11-.9-2.01-2.01-2.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M10.42 34.72c-.26 0-.51-.1-.71-.29l-3.4-3.4c-.19-.19-.29-.44-.29-.71s.11-.52.29-.71l3.4-3.4a.996.996 0 1 1 1.41 1.41l-2.7 2.7 2.7 2.7c.39.39.39 1.02 0 1.41a.96.96 0 0 1-.7.29zM20.7 34.72c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l2.7-2.7-2.7-2.7a.996.996 0 1 1 1.41-1.41l3.4 3.4c.19.19.29.44.29.71s-.11.52-.29.71l-3.4 3.4c-.19.2-.44.29-.7.29zM12.54 37.8a.994.994 0 0 1-.9-1.42l6.04-12.95c.23-.5.83-.72 1.33-.48.5.23.72.83.48 1.33l-6.04 12.95c-.17.35-.53.57-.91.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#121923",
    stroke: "#ffffff",
    d: "M30.53 36.12v25.87c0 1.11.9 2.01 2.01 2.01h29.38c1.11 0 2.01-.9 2.01-2.01V36.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M58.9 40.14H35.55c-.55 0-1 .45-1 1v9.28c0 .55.45 1 1 1H58.9c.55 0 1-.45 1-1v-9.28c0-.56-.44-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M44.18 56.7h-9.64c-.55 0-1-.45-1-1s.45-1 1-1h9.64c.55 0 1 .45 1 1s-.45 1-1 1zM39.15 61.14h-4.61c-.55 0-1-.45-1-1s.45-1 1-1h4.61c.55 0 1 .45 1 1s-.45 1-1 1zM59.9 56.86h-9.64c-.55 0-1-.45-1-1s.45-1 1-1h9.64c.55 0 1 .45 1 1s-.44 1-1 1zM54.87 61.14h-4.61c-.55 0-1-.45-1-1s.45-1 1-1h4.61c.55 0 1 .45 1 1s-.44 1-1 1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.68,
    cy: 51.5,
    r: 1.01,
    fill: "currentColor"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcCustomFrontPage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_custom_front_page.ff0aeda2.svg";
export { ForwardRef as ReactComponent };